export const getSum = (input: number[]) => {
  return input.reduce((acc, curr) => acc + curr, 0)
}
